import React, { Component ,useState} from 'react';
import { Link } from 'react-router-dom';
import Ico from './iconBox';



import alBarari01 from "../assets/images/Al Barari/Al Barari 01.jpeg";
import alBarari02 from "../assets/images/Al Barari/Al Barari 02.jpeg";
import alBarari03 from "../assets/images/Al Barari/Al Barari 03.jpeg";
import alBarari04 from "../assets/images/Al Barari/Al Barari 04.jpeg";
import alBarari05 from "../assets/images/Al Barari/Al Barari 05.jpeg";
import alBarari06 from "../assets/images/Al Barari/Al Barari 06.jpeg";

import alBarsha01 from "../assets/images/Al Barsha South-Dubai/01.jpeg";
import alBarsha02 from "../assets/images/Al Barsha South-Dubai/02.jpeg";
import alBarsha03 from "../assets/images/Al Barsha South-Dubai/03.jpeg";

import alMarwan08 from "../assets/images/Al Marwan Group/08.jpeg";
import alMarwan09 from "../assets/images/Al Marwan Group/09.jpeg";
import alMarwan10 from "../assets/images/Al Marwan Group/10.jpeg";
import alMarwan11 from "../assets/images/Al Marwan Group/Al marwan 11.jpeg";
import alMarwan12 from "../assets/images/Al Marwan Group/Al marwan 12.jpeg";
import alMarwan13 from "../assets/images/Al Marwan Group/Al marwan 13.jpeg";
import alMarwan14 from "../assets/images/Al Marwan Group/Al marwan 14.jpeg";
import alMarwan15 from "../assets/images/Al Marwan Group/Al marwan 15.jpeg";

import alTaween01 from "../assets/images/Al Taween Mountain-200 date palms plantation/Al taween Mountain 1.jpeg";
import alTaween02 from "../assets/images/Al Taween Mountain-200 date palms plantation/Al taween mountain 02.jpeg";
import alTaween03 from "../assets/images/Al Taween Mountain-200 date palms plantation/Al taween mountain 03.jpeg";
import alTaween04 from "../assets/images/Al Taween Mountain-200 date palms plantation/Al taween mountain 04.jpeg";

import dubaiHills01 from "../assets/images/Dubai Hills villa/Dubai hills villa 01.jpeg";
import dubaiHills02 from "../assets/images/Dubai Hills villa/Dubai hills villa 02.jpeg";
import dubaiHills03 from "../assets/images/Dubai Hills villa/Dubai Hills villa 03.jpeg";
import dubaiHills04 from "../assets/images/Dubai Hills villa/Dubai hills villa 04.jpeg";
import dubaiHills05 from "../assets/images/Dubai Hills villa/Dubai hills villa 05.jpeg";

import theVilla01 from "../assets/images/Dubai land-The Villa/The villa 01.jpeg";
import theVilla02 from "../assets/images/Dubai land-The Villa/The villa 02.jpeg";
import theVilla03 from "../assets/images/Dubai land-The Villa/The villa 03.jpeg";
import theVilla04 from "../assets/images/Dubai land-The Villa/The villa 04.jpeg";
import theVilla05 from "../assets/images/Dubai land-The Villa/The villa 05.jpeg";

import grass01 from "../assets/images/Grass plantation-Dubai/Grass plantation 1.jpeg";
import grass02 from "../assets/images/Grass plantation-Dubai/Grass plantation 2.jpeg";
import grass03 from "../assets/images/Grass plantation-Dubai/Grass plantation 3.jpeg";
import grass04 from "../assets/images/Grass plantation-Dubai/Grass plantation 4.jpeg";
import grass05 from "../assets/images/Grass plantation-Dubai/Grass plantation 5.jpeg";
import grass06 from "../assets/images/Grass plantation-Dubai/Grass plantation 6.jpeg";
import grass07 from "../assets/images/Grass plantation-Dubai/Grass plantation 7.jpeg";
import grass08 from "../assets/images/Grass plantation-Dubai/Grass plantation 8.jpeg";

import hyde01 from "../assets/images/Hyde Walk By Imtiaz-Artificial palm plantation/Hyde walk- By Imtiaz 2-01.jpeg";
import hyde02 from "../assets/images/Hyde Walk By Imtiaz-Artificial palm plantation/Hyde walk- By Imtiaz 4-01.jpeg";
import hyde03 from "../assets/images/Hyde Walk By Imtiaz-Artificial palm plantation/Hyde walk- By Imtiaz 5-02.jpeg";
import hyde04 from "../assets/images/Hyde Walk By Imtiaz-Artificial palm plantation/Hyde walk- By Imtiaz 6 (1)-01.jpeg";
import hyde05 from "../assets/images/Hyde Walk By Imtiaz-Artificial palm plantation/Hyde walk- By Imtiaz 7-01.jpeg";
import hyde06 from "../assets/images/Hyde Walk By Imtiaz-Artificial palm plantation/Hyde walk- By Imtiaz 8-01.jpeg";
import hyde07 from "../assets/images/Hyde Walk By Imtiaz-Artificial palm plantation/Hyde walk- By Imtiaz 9-01.jpeg";

import imtiaz01 from "../assets/images/Imtiaz developments/Imtiaz development 01.jpeg";
import imtiaz02 from "../assets/images/Imtiaz developments/Imtiaz development 02.jpeg";
import imtiaz03 from "../assets/images/Imtiaz developments/Imtiaz development 03.jpeg";
import imtiaz04 from "../assets/images/Imtiaz developments/Imtiaz development 04.jpeg";

import jumeirah01 from "../assets/images/Jumeirah Golf Estate-Decking work/Jumeirah golf 01.jpeg";
import jumeirah02 from "../assets/images/Jumeirah Golf Estate-Decking work/Jumeirah golf 02.jpeg";
import jumeirah03 from "../assets/images/Jumeirah Golf Estate-Decking work/Jumeirah golf 03.jpeg";

import springfield01 from "../assets/images/Spring field properties- Olive tree plantation/01.jpeg";
import springfield02 from "../assets/images/Spring field properties- Olive tree plantation/02.jpeg";
import springfield03 from "../assets/images/Spring field properties- Olive tree plantation/03.jpeg";

import springs01 from "../assets/images/Springs -Private villa/Springs private villa 01.jpeg";
import springs02 from "../assets/images/Springs -Private villa/Springs-Private villa 02.jpeg";
import springs03 from "../assets/images/Springs -Private villa/Springs-Private villa 03.jpeg";
import springs04 from "../assets/images/Springs -Private villa/Springs-Private villa 04.jpeg";
import springs05 from "../assets/images/Springs -Private villa/Springs private villa 05.jpeg";

import tilal01 from "../assets/images/Tilal Al Ghaf/T1.jpeg";
import tilal02 from "../assets/images/Tilal Al Ghaf/T2.jpeg";
import tilal03 from "../assets/images/Tilal Al Ghaf/T3.jpeg";



// import person1 from '../assets/images/person_1.jpg';
// import person2 from '../assets/images/person_2.jpg';
// import person3 from '../assets/images/person_3.jpg';
// import person4 from '../assets/images/person_4.jpg';

const Home = ( props ) => {




const [selectedProject, setSelectedProject] = useState(null);
const [currentImage, setCurrentImage] = useState(0);



      const projects = [
  {
    title: "Al Barari",
    category: "Landscape Project",
    images: [
      alBarari01,
      alBarari02,
      alBarari03,
      alBarari04,
      alBarari05,
      alBarari06,
    ],
  },

  {
    title: "Al Barsha South - Dubai",
    category: "Landscape Project",
    images: [
      alBarsha01,
      alBarsha02,
      alBarsha03,
    ],
  },

  {
    title: "Al Marwan Group",
    category: "Landscape Project",
    images: [
      alMarwan08,
      alMarwan09,
      alMarwan10,
      alMarwan11,
      alMarwan12,
      alMarwan13,
      alMarwan14,
      alMarwan15,
    ],
  },

  {
    title: "Al Taween Mountain",
    category: "200 Date Palms Plantation",
    images: [
      alTaween01,
      alTaween02,
      alTaween03,
      alTaween04,
    ],
  },

  {
    title: "Dubai Hills Villa",
    category: "Villa Landscape",
    images: [
      dubaiHills01,
      dubaiHills02,
      dubaiHills03,
      dubaiHills04,
      dubaiHills05,
    ],
  },

  {
    title: "Dubai Land - The Villa",
    category: "Villa Landscape",
    images: [
      theVilla01,
      theVilla02,
      theVilla03,
      theVilla04,
      theVilla05,
    ],
  },

  {
    title: "Grass Plantation - Dubai",
    category: "Plantation Project",
    images: [
      grass01,
      grass02,
      grass03,
      grass04,
      grass05,
      grass06,
      grass07,
      grass08,
    ],
  },

  {
    title: "Hyde Walk By Imtiaz",
    category: "Artificial Palm Plantation",
    images: [
      hyde01,
      hyde02,
      hyde03,
      hyde04,
      hyde05,
      hyde06,
      hyde07,
    ],
  },

  {
    title: "Imtiaz Developments",
    category: "Landscape Project",
    images: [
      imtiaz01,
      imtiaz02,
      imtiaz03,
      imtiaz04,
    ],
  },

  {
    title: "Jumeirah Golf Estate",
    category: "Decking Work",
    images: [
      jumeirah01,
      jumeirah02,
      jumeirah03,
    ],
  },

  {
    title: "Springfield Properties",
    category: "Olive Tree Plantation",
    images: [
      springfield01,
      springfield02,
      springfield03,
    ],
  },

  {
    title: "Springs - Private Villa",
    category: "Private Villa",
    images: [
      springs01,
      springs02,
      springs03,
      springs04,
      springs05,
    ],
  },

  {
    title: "Tilal Al Ghaf",
    category: "Landscape Project",
    images: [
      tilal01,
      tilal02,
      tilal03,
    ],
  },
];





        return (
            <div>
            
      

<section className="modern-projects-section">
  <div className="container">

    <div className="modern-projects-heading">
      <span>OUR PORTFOLIO</span>

      <h3 className="modern-projects-title">
        Our Completed Projects
      </h3>

      <span className="modern-projects-line"></span>

      <p>
        Explore our completed landscape design, plantation, decking,
        and outdoor projects across Dubai and the UAE.
      </p>
    </div>


    <div className="modern-projects-grid">

      {projects.map((project, index) => (

        <div
          className="modern-project-card"
          key={index}
          onClick={() => {
            setSelectedProject(project);
            setCurrentImage(0);
          }}
        >

          <img
            src={project.images[0]}
            alt={project.title}
            className="modern-project-img"
          />

          <div className="modern-project-overlay">

            <span>
              {project.category}
            </span>

            <h4>
              {project.title}
            </h4>

            <small>
              View Project →
            </small>

          </div>

        </div>

      ))}

    </div>

  </div>
</section>


{/* =========================
    PROJECT IMAGE SLIDER
========================= */}

{selectedProject && (

  <div
    className="project-lightbox"
    onClick={() => setSelectedProject(null)}
  >

    <div
      className="project-lightbox-content"
      onClick={(e) => e.stopPropagation()}
    >

      {/* Close */}

      <button
        className="project-close-btn"
        onClick={() => setSelectedProject(null)}
      >
        ×
      </button>


      {/* Project Title */}

      <div className="project-lightbox-title">

        <span>
          {selectedProject.category}
        </span>

        <h3>
          {selectedProject.title}
        </h3>

      </div>


      {/* Main Image */}

      <div className="project-slider">

        <button
          className="project-slider-btn project-prev"
          onClick={() =>
            setCurrentImage(
              currentImage === 0
                ? selectedProject.images.length - 1
                : currentImage - 1
            )
          }
        >
          ❮
        </button>


        <img
          src={selectedProject.images[currentImage]}
          alt={`${selectedProject.title} ${currentImage + 1}`}
          className="project-slider-main-img"
        />


        <button
          className="project-slider-btn project-next"
          onClick={() =>
            setCurrentImage(
              currentImage === selectedProject.images.length - 1
                ? 0
                : currentImage + 1
            )
          }
        >
          ❯
        </button>

      </div>


      {/* Image Counter */}

      <div className="project-image-counter">
        {currentImage + 1} / {selectedProject.images.length}
      </div>


      {/* Thumbnails */}

      <div className="project-thumbnails">

        {selectedProject.images.map((image, index) => (

          <div
            key={index}
            className={`project-thumbnail ${
              currentImage === index ? "active" : ""
            }`}
            onClick={() => setCurrentImage(index)}
          >

            <img
              src={image}
              alt={`${selectedProject.title} thumbnail ${index + 1}`}
            />

          </div>

        ))}

      </div>

    </div>

  </div>

)}









<style>
{

`
/* =========================
   PROJECT LIGHTBOX
========================= */

/* =========================================
   PREMIUM COMPLETED PROJECTS
========================================= */

.modern-projects-section {
  position: relative;
  padding: 100px 0;
  background: #f8f8f5;
}

.modern-projects-section .container {
  max-width: 1250px;
}


/* =========================================
   SECTION HEADING
========================================= */

.modern-projects-heading {
  max-width: 760px;
  margin: 0 auto 55px;
  text-align: center;
}

.modern-projects-heading > span:first-child {
  display: inline-block;
  margin-bottom: 12px;

  color: #5b7748;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
}

.modern-projects-title {
  margin: 0;

  color: #1d241c;
  font-size: 42px;
  font-weight: 700;
  line-height: 1.2;
}

.modern-projects-line {
  display: block;

  width: 55px;
  height: 2px;

  margin: 20px auto 22px;

  background: #5b7748;
}

.modern-projects-heading p {
  max-width: 680px;
  margin: 0 auto;

  color: #72776f;
  font-size: 15px;
  line-height: 1.8;
}


/* =========================================
   PROJECT GRID
========================================= */

.modern-projects-grid {
  display: grid;

  grid-template-columns: repeat(3, 1fr);

  gap: 28px;
}


/* =========================================
   PROJECT CARD
========================================= */

.modern-project-card {
  position: relative;

  height: 390px;

  overflow: hidden;

  background: #ddd;

  border-radius: 8px;

  cursor: pointer;

  box-shadow: 0 8px 25px rgba(0, 0, 0, .07);

  transition:
    transform .45s ease,
    box-shadow .45s ease;
}

.modern-project-card:hover {
  transform: translateY(-8px);

  box-shadow: 0 20px 45px rgba(0, 0, 0, .15);
}


/* =========================================
   PROJECT IMAGE
========================================= */

.modern-project-img {
  width: 100%;
  height: 100%;

  display: block;

  object-fit: cover;

  transition:
    transform .8s cubic-bezier(.2,.7,.2,1);
}

.modern-project-card:hover .modern-project-img {
  transform: scale(1.08);
}


/* =========================================
   DARK IMAGE OVERLAY
========================================= */

.modern-project-card::after {
  content: "";

  position: absolute;

  inset: 0;

  pointer-events: none;

  background:
    linear-gradient(
      to top,
      rgba(8, 12, 7, .88) 0%,
      rgba(8, 12, 7, .55) 30%,
      rgba(8, 12, 7, .08) 65%,
      rgba(8, 12, 7, 0) 100%
    );
}


/* =========================================
   PROJECT CONTENT
========================================= */

.modern-project-overlay {
  position: absolute;

  z-index: 2;

  left: 0;
  right: 0;
  bottom: 0;

  padding: 32px 30px 28px;

  color: #fff;

  transform: translateY(5px);

  transition: transform .4s ease;
}

.modern-project-card:hover
.modern-project-overlay {
  transform: translateY(0);
}


/* Category */

.modern-project-overlay span {
  display: block;

  margin-bottom: 9px;

  color: #b8d2a9;

  font-size: 10px;
  font-weight: 700;

  letter-spacing: 2.2px;

  text-transform: uppercase;
}


/* Project Name */

.modern-project-overlay h4 {
  margin: 0;

  color: #fff;

  font-size: 23px;
  font-weight: 600;

  line-height: 1.3;
}


/* Description */

.modern-project-overlay p {
  margin: 7px 0 0;

  color: rgba(255, 255, 255, .78);

  font-size: 13px;

  line-height: 1.6;
}


/* View Project */

.modern-project-overlay small {
  display: inline-flex;

  align-items: center;

  margin-top: 16px;

  color: #fff;

  font-size: 11px;
  font-weight: 600;

  letter-spacing: .5px;

  opacity: 0;

  transform: translateY(8px);

  transition:
    opacity .35s ease,
    transform .35s ease;
}

.modern-project-card:hover
.modern-project-overlay small {
  opacity: 1;

  transform: translateY(0);
}


/* =========================================
   PROJECT NUMBER
========================================= */

.modern-project-card:nth-child(1)::before,
.modern-project-card:nth-child(2)::before,
.modern-project-card:nth-child(3)::before,
.modern-project-card:nth-child(4)::before,
.modern-project-card:nth-child(5)::before,
.modern-project-card:nth-child(6)::before,
.modern-project-card:nth-child(7)::before,
.modern-project-card:nth-child(8)::before,
.modern-project-card:nth-child(9)::before,
.modern-project-card:nth-child(10)::before,
.modern-project-card:nth-child(11)::before,
.modern-project-card:nth-child(12)::before,
.modern-project-card:nth-child(13)::before {
  position: absolute;

  z-index: 3;

  top: 20px;
  right: 20px;

  color: rgba(255,255,255,.75);

  font-size: 11px;
  font-weight: 600;

  letter-spacing: 1px;
}

.modern-project-card:nth-child(1)::before {
  content: "01";
}

.modern-project-card:nth-child(2)::before {
  content: "02";
}

.modern-project-card:nth-child(3)::before {
  content: "03";
}

.modern-project-card:nth-child(4)::before {
  content: "04";
}

.modern-project-card:nth-child(5)::before {
  content: "05";
}

.modern-project-card:nth-child(6)::before {
  content: "06";
}

.modern-project-card:nth-child(7)::before {
  content: "07";
}

.modern-project-card:nth-child(8)::before {
  content: "08";
}

.modern-project-card:nth-child(9)::before {
  content: "09";
}

.modern-project-card:nth-child(10)::before {
  content: "10";
}

.modern-project-card:nth-child(11)::before {
  content: "11";
}

.modern-project-card:nth-child(12)::before {
  content: "12";
}

.modern-project-card:nth-child(13)::before {
  content: "13";
}


/* =========================================
   LIGHTBOX
========================================= */

.project-lightbox {
  position: fixed;

  inset: 0;

  z-index: 999999;

  display: flex;

  align-items: center;
  justify-content: center;

  padding: 25px;

  background: rgba(10, 13, 9, .94);

  backdrop-filter: blur(8px);

  animation: lightboxFade .3s ease;
}

@keyframes lightboxFade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}


/* =========================================
   LIGHTBOX CONTENT
========================================= */

.project-lightbox-content {
  position: relative;

  width: 100%;
  max-width: 1150px;

  padding: 28px;

  background: #171a16;

  border: 1px solid rgba(255,255,255,.08);

  border-radius: 12px;

  box-shadow: 0 30px 80px rgba(0,0,0,.5);
}


/* =========================================
   CLOSE BUTTON
========================================= */

.project-close-btn {
  position: absolute;

  z-index: 10;

  top: 18px;
  right: 18px;

  width: 42px;
  height: 42px;

  display: flex;

  align-items: center;
  justify-content: center;

  padding: 0;

  border: 1px solid rgba(255,255,255,.15);

  border-radius: 50%;

  color: #fff;

  background: rgba(255,255,255,.08);

  font-size: 27px;
  font-weight: 300;

  line-height: 1;

  cursor: pointer;

  transition: .3s;
}

.project-close-btn:hover {
  color: #fff;

  background: #5b7748;

  border-color: #5b7748;

  transform: rotate(90deg);
}


/* =========================================
   LIGHTBOX TITLE
========================================= */

.project-lightbox-title {
  padding: 0 60px 20px 2px;
}

.project-lightbox-title span {
  display: block;

  margin-bottom: 6px;

  color: #a9c59b;

  font-size: 10px;
  font-weight: 700;

  letter-spacing: 2px;

  text-transform: uppercase;
}

.project-lightbox-title h3 {
  margin: 0;

  color: #fff;

  font-size: 27px;
  font-weight: 600;
}


/* =========================================
   MAIN SLIDER
========================================= */

.project-slider {
  position: relative;

  width: 100%;
  height: 610px;

  display: flex;

  align-items: center;
  justify-content: center;

  overflow: hidden;

  background: #0d0f0c;

  border-radius: 8px;
}

.project-slider-main-img {
  width: 100%;
  height: 100%;

  display: block;

  object-fit: contain;

  animation: imageFade .3s ease;
}

@keyframes imageFade {
  from {
    opacity: .5;
  }

  to {
    opacity: 1;
  }
}


/* =========================================
   SLIDER ARROWS
========================================= */

.project-slider-btn {
  position: absolute;

  z-index: 5;

  top: 50%;

  width: 48px;
  height: 48px;

  display: flex;

  align-items: center;
  justify-content: center;

  padding: 0;

  border: 1px solid rgba(255,255,255,.2);

  border-radius: 50%;

  color: #fff;

  background: rgba(0,0,0,.55);

  font-size: 18px;

  cursor: pointer;

  transform: translateY(-50%);

  transition: .3s;
}

.project-slider-btn:hover {
  background: #5b7748;

  border-color: #5b7748;

  transform: translateY(-50%) scale(1.08);
}

.project-prev {
  left: 20px;
}

.project-next {
  right: 20px;
}


/* =========================================
   COUNTER
========================================= */

.project-image-counter {
  padding: 14px 0 12px;

  color: #aaa;

  text-align: center;

  font-size: 12px;
}


/* =========================================
   THUMBNAILS
========================================= */

.project-thumbnails {
  display: flex;

  align-items: center;

  gap: 9px;

  width: 100%;

  padding: 2px 0 4px;

  overflow-x: auto;

  scrollbar-width: thin;
}

.project-thumbnail {
  flex: 0 0 82px;

  width: 82px;
  height: 58px;

  overflow: hidden;

  border: 2px solid transparent;

  border-radius: 5px;

  opacity: .45;

  cursor: pointer;

  transition: .3s;
}

.project-thumbnail img {
  width: 100%;
  height: 100%;

  display: block;

  object-fit: cover;

  transition: .3s;
}

.project-thumbnail:hover {
  opacity: .9;
}

.project-thumbnail:hover img {
  transform: scale(1.05);
}

.project-thumbnail.active {
  border-color: #8db67b;

  opacity: 1;
}


/* =========================================
   DESKTOP HOVER DETAILS
========================================= */

@media (min-width: 992px) {

  .modern-project-card:nth-child(3n + 1) {
    transform-origin: left center;
  }

}


/* =========================================
   TABLET
========================================= */

@media (max-width: 991px) {

  .modern-projects-section {
    padding: 80px 20px;
  }

  .modern-projects-grid {
    grid-template-columns: repeat(2, 1fr);

    gap: 22px;
  }

  .modern-project-card {
    height: 350px;
  }

  .modern-project-title {
    font-size: 36px;
  }

  .project-slider {
    height: 520px;
  }

}


/* =========================================
   MOBILE
========================================= */

@media (max-width: 767px) {

  .modern-projects-section {
    padding: 65px 15px;
  }

  .modern-projects-heading {
    margin-bottom: 38px;
  }

  .modern-project-title,
  .modern-projects-title {
    font-size: 30px;
  }

  .modern-projects-heading p {
    font-size: 14px;
  }

  .modern-projects-grid {
    grid-template-columns: 1fr;

    gap: 18px;
  }

  .modern-project-card {
    height: 300px;

    border-radius: 7px;
  }

  .modern-project-overlay {
    padding: 25px 22px 22px;
  }

  .modern-project-overlay h4 {
    font-size: 20px;
  }

  .modern-project-overlay small {
    opacity: 1;

    transform: none;
  }


  /* Lightbox */

  .project-lightbox {
    padding: 8px;
  }

  .project-lightbox-content {
    padding: 15px;

    border-radius: 8px;
  }

  .project-close-btn {
    top: 10px;
    right: 10px;

    width: 38px;
    height: 38px;
  }

  .project-lightbox-title {
    padding: 3px 48px 15px 2px;
  }

  .project-lightbox-title h3 {
    font-size: 20px;
  }

  .project-slider {
    height: 390px;

    border-radius: 6px;
  }

  .project-slider-btn {
    width: 40px;
    height: 40px;

    font-size: 15px;
  }

  .project-prev {
    left: 10px;
  }

  .project-next {
    right: 10px;
  }

  .project-thumbnail {
    flex: 0 0 68px;

    width: 68px;
    height: 50px;
  }

}


/* =========================================
   SMALL MOBILE
========================================= */

@media (max-width: 400px) {

  .modern-project-card {
    height: 270px;
  }

  .modern-project-title,
  .modern-projects-title {
    font-size: 27px;
  }

  .project-slider {
    height: 330px;
  }

  .project-lightbox-content {
    padding: 10px;
  }

}
`
}
</style>






            {/* </div> */}
        
          </div>
        )

}

export default Home;